import { render, staticRenderFns } from "./TrainingNutrition.vue?vue&type=template&id=99588ade&scoped=true"
import script from "./TrainingNutrition.vue?vue&type=script&lang=js"
export * from "./TrainingNutrition.vue?vue&type=script&lang=js"
import style0 from "./TrainingNutrition.vue?vue&type=style&index=0&id=99588ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99588ade",
  null
  
)

export default component.exports